import React, { ReactElement, useEffect } from 'react';
import { Badge, Button, ButtonGroup, Col, Dropdown, Row } from 'react-bootstrap';
import EnteteDePage from '../Utils/EnteteDePage';
import { LinkContainer } from 'react-router-bootstrap';
import { BiFile, BiPlus } from 'react-icons/bi';
import TableVisualizer from './DragAndDropTable';
import axios from 'axios';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { useGetQuery } from '../../../Utils/api';
import { HistoriqueLogs } from '../../../../../common/src/entities';

export default function Etiquettes(): ReactElement {
    const EXPORTER = ' Exporter en CSV';

    useEffect(() => {}, []);
    document.title = 'Étiquettes - Dashboard';
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/etiquette`);

    async function downloadExcel() {
        // Envoyer la demande GET à l'API.
        const response = await axios.get('/api/etiquettes/export-etiquettes-csv', { responseType: 'arraybuffer' });

        // Créer un lien de téléchargement pour le fichier Excel.
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'etiquettes.csv');
        document.body.appendChild(link);
        link.click();
    }

    return (
        <>
            <Row style={{ marginBottom: '40px' }}>
                <Col>
                    <EnteteDePage texte="Étiquettes" cacherBoutonRetour />
                </Col>

                <Col xs="auto">
                    <ButtonGroup>
                        <LinkContainer to="new">
                            <Button size="sm" variant="outline-primary" className="d-flex align-items-center">
                                <BiPlus /> Ajouter une catégorie
                            </Button>
                        </LinkContainer>
                        <Button
                            size="sm"
                            variant="outline-secondary"
                            className="d-flex align-items-center"
                            onClick={downloadExcel}
                        >
                            <BiFile />
                            {EXPORTER}
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
            <Badge variant="light" className="my-2 bg-white shadow-sm p-2">
                Dernière modification:
                {listLogs.data?.[listLogs.data.length - 1]?.date_modification
                    ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                    : 'Aucune modificiation'}{' '}
                {listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                    ? ' par ' + listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                    : ''}{' '}
            </Badge>{' '}
            <TableVisualizer />
            <LogsLoader id={-1} tableName={'etiquette'} />
        </>
    );
}
